module.exports = __webpack_public_path__ + "img/50_2.4fa2c21f.png";